var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 5.875C9.25 10.2242 12.7758 13.75 17.125 13.75C19.3282 13.75 21.3201 12.8452 22.7494 11.3869C22.75 11.4246 22.75 11.4623 22.75 11.5C22.75 17.7131 17.7131 22.75 11.5 22.75C5.28679 22.75 0.25 17.7131 0.25 11.5C0.25 5.28679 5.28679 0.25 11.5 0.25C11.5377 0.25 11.5754 0.25 11.6131 0.250551C10.1548 1.67985 9.25 3.67177 9.25 5.875ZM2.5 11.5C2.5 16.4706 6.52943 20.5 11.5 20.5C14.9406 20.5 17.9303 18.5694 19.4448 15.7324C18.6938 15.9085 17.9164 16 17.125 16C11.5331 16 7 11.4669 7 5.875C7 5.08354 7.0915 4.30615 7.26764 3.55525C4.43062 5.06976 2.5 8.05941 2.5 11.5Z",
    fill: "#9E9C9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNight);
export default __webpack_public_path__ + "static/media/icon-night.8144aa66e8af3660021a622888d5e39d.svg";
export { ForwardRef as ReactComponent };